import QuickCart from "../modules/quick-cart";

const Cart = {
  init: () => {
    Cart.events();
  },

  events: () => {
    $("[name=apply_coupon]").on("click", function (e) {
      const cuponCodeEl = $("#coupon_code");

      if (!cuponCodeEl.val()) {
        cuponCodeEl.addClass("error");
        e.preventDefault();
      }
    });

    let timeout;
    $(".woocommerce-cart").on("change", "input.qty", function () {
      let input = $(this);

      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        Cart.updateQuantity(input);
      }, 500);
    });
  },

  updateQuantity: (input) => {
    let regex = /cart\[(.*?)\]\[qty\]/;
    let found = input.attr("name").match(regex);
    if (!found[1]) {
      return;
    }
    let item_key = found[1];
    let qty = input.val();

    $(".woocommerce-cart-form").addClass("cart-loading");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "update_cart_item_quantity",
        item_key: item_key,
        qty: qty,
      },
    })
      .done((response) => {
        if (response.html) {
          $(".woocommerce-cart .woocommerce").html(response.html);
        }
        // if (response.items) {
        //   let items = Object.keys(response.items);
        //   items.forEach((key) => {
        //     let data = response.items[key];
        //     const item = $(`.woocommerce-cart-form tr[data-id="${key}"]`);
        //     item.find(".price--subtotal").html(data.price);
        //   });
        // }

        // if (response.vat_rates) {
        //   let vatRates = Object.keys(response.vat_rates);
        //   vatRates.forEach((key) => {
        //     $(`.cart-totals__item[data-id="${key}"] span`).html(
        //       response.vat_rates[key]
        //     );
        //   });
        // }

        // $(".woocommerce-cart-form .cart-total").html(response.total);
        // $(".woocommerce-cart-form .cart-totals__price").html(
        //   response.total_vat
        // );
        if (window.wc_add_to_cart_params.is_cart !== "1") {
          setTimeout(() => {
            QuickCart.render();
          }, 500);
        }
      })
      .always(() => {
        $(".woocommerce-cart-form").removeClass("cart-loading");
      });
  },
};
export default Cart;
